import { type TBreakpointName, useBreakpoint } from "@hooks/useBreakpoint";
import { Grid } from "@mantine/core";
import type { FC } from "react";
import InfoCard, { type InfoCardProps } from "./InfoCard";

type TCardsPerRow = 1 | 2 | 3 | 4;
type PartialBreakpointMap = Partial<Record<TBreakpointName, TCardsPerRow>>;

interface Props {
  cards: InfoCardProps[];
  cardsPerRow?: TCardsPerRow;
}

const InfoCardGrid: FC<Props> = ({ cards, cardsPerRow = 3 }) => {
  const { breakpointName } = useBreakpoint();

  const colsStatement: Record<TCardsPerRow, PartialBreakpointMap> = {
    1: { base: 1, xs: 2, sm: 2, md: 3, lg: 4, xl: 4 },
    2: { base: 1, xs: 2, sm: 2, md: 4, lg: 4, xl: 4 },
    3: { base: 1, xs: 1, sm: 2, md: 2, lg: 3, xl: 3 },
    4: { base: 1, xs: 2, sm: 2, md: 2, lg: 2, xl: 4 },
  };

  const elements = cards.map((card) => {
    return (
      <Grid.Col
        span={12 / (colsStatement[cardsPerRow][breakpointName] ?? 1)}
        key={card.title}
      >
        <InfoCard
          key={card.title}
          {...card}
          classNames={{
            ...card.classNames,
            root: `w-full h-full ${card.classNames?.root}`,
          }}
        />
      </Grid.Col>
    );
  });

  return (
    <Grid grow className="w-full px-3" gutter="md">
      {elements}
    </Grid>
  );
};

export default InfoCardGrid;
